import { Vector3 as c } from "three";
import { Vectors as l } from "../../utils/index36.js";
import { isPolygonClockwise as u } from "../is-polygon-clockwise/index.js";
import { RayLineIntersection as d } from "../ray-line-intersection/index.js";
const m = new c();
function I({ polygon: s, ray: i, calculateEnters: o = !0 }) {
  s = u(s) ? s : s.slice().reverse();
  let e = [];
  for (let t = 0; t < s.length - 1; t++) {
    const r = [s[t], s[t + 1]], n = d({ ray: i, line: r });
    if (!n)
      continue;
    let f;
    o && (f = m.subVectors(r[1], r[0]).cross(l.Up).normalize().dot(i.dir) >= 0), e.push({ point: n, index: t, enters: f });
  }
  return e.length < 2 ? [] : (o && (e = p(e, i)), e);
}
function p(s, i) {
  const o = s.slice().sort(
    ({ point: t, enters: r }, { point: n }) => t.distanceToSquared(n) > 1e-4 ? t.dot(i.dir) - n.dot(i.dir) : r === !1 ? -1 : 1
  );
  let e = o.filter(
    (t, r, n) => r === 0 || !(t.point.distanceToSquared(n[r - 1].point) < 1e-3 && t.enters === n[r - 1].enters)
  );
  return e = o.filter(
    (t, r, n) => r === 0 || !(t.enters === !1 && t.enters === n[r - 1].enters)
  ), e.reverse(), e = e.filter(
    (t, r, n) => r === 0 || !(t.enters === !0 && t.enters === n[r - 1].enters)
  ), e.reverse(), e[0].enters === !1 && e.shift(), e[e.length - 1].enters === !0 && e.pop(), e;
}
export {
  I as rayPolygonIntersection
};
//# sourceMappingURL=index.js.map
